<template>
  <v-app>
    <v-dialog v-model="logoutConfirm" max-width="600px">
      <v-card>
        <v-card-title>¿Realmente deseas salir?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="logoutConfirm = false" text>Cancelar</v-btn>
          <v-btn @click="onLogoutConfirm" text color="primary">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer v-model="showNavigation" left app>
      <v-toolbar elevation="0">
        <img src="@/assets/logo.png" style="height: 46px; margin: 10px;" />
      </v-toolbar>

      <v-list nav dense rounded>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in routes" :key="i" :to="item.route">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-btn @click="showNavigation = true" icon>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title class="title">
        <span>{{$router.history.current.name}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu transition="slide-x-transition" bottom right v-if="isLoggedIn">
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on">
            <v-icon>account_circle</v-icon>
          </v-avatar>
        </template>

        <v-list>
          <v-list-item>{{userFullName}}</v-list-item>
          <v-list-item to="/mi-cuenta">Mi cuenta</v-list-item>
          <v-list-item @click="tryLogout">Salir</v-list-item>
        </v-list>
      </v-menu>
      <div v-else>
        <v-btn to="/ingreso" text>Ingresar</v-btn>
      </div>
    </v-app-bar>

    <v-content app class="app-content">
      <transition-page>
        <router-view />
      </transition-page>
    </v-content>
  </v-app>
</template>
<script>
import TransitionPage from "./components/TransitionPage";
export default {
  components: { TransitionPage },
  data: () => ({
    showNavigation: null,
    logoutConfirm: false,
    accountData: {},
    routes: [
      {
        name: "Buscar cita",
        icon: "search",
        route: "/"
      },
      {
        name: "Mis citas",
        icon: "calendar_today",
        route: "/mis-citas"
      },
      {
        name: "Mi cuenta",
        icon: "account_box",
        route: "/mi-cuenta"
      }
    ]
  }),
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    userFullName: function() {
      return this.$store.getters.getUserFullName;
    }
  },
  methods: {
    login() {},
    openSidenav: function() {},
    onLogoutConfirm: function() {
      this.$store.dispatch("logout").then(() => {
        this.logoutConfirm = false;
        this.$router.push("/");
      });
    },
    tryLogout: function() {
      this.logoutConfirm = true;
    },
    getMyAccount: function() {
      const axios = require("axios");
      axios.get("getMyAccountData").then(
        async res => {
          this.accountData = res.data;
          await this.$store.dispatch("commitUser", res.data);
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  created: function() {
    // Obtener datos de cuenta si está logueado
    if (this.isLoggedIn) {
      this.getMyAccount();
    }
  },
  watch: {}
};
</script>

<style>
.app-content .v-content__wrap > :first-child {
  min-height: calc(100vh - 64px);
}
</style>
